module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/thumbs/58-a2b1be4c07826613fe7e9f6eeda5f352.webp";